import { useState, useEffect } from "react";
//components
import Label from "../../../../components/ui/labels/Label";
import { Toggle } from "../../../../components/ui/inputs/Toggle"
//hooks
import { useLoading } from "../../../../contexts/LoadingContext";
import { useError} from "../../../../contexts/ErrorContext"
//api
import { updateGroupPermissionsAPI } from '../../../../services/groupsAPI'

//list of the resources that require permissions for access
//used to generate table
const permissionResources = [
    "runs",
    "jobs",
    "agms",
    "subchains",
    "users",
    "livetracks",
    "sitemaps",
    'pois'
]

/**
 * Toggle permissions for a group
 * 
 * @param {string} groupID needed to make api call when updating permissions
 * @param {Object} groupPermissions nested object with permissions assigned to resources, see example
 * @example
 * {
        "jobs": {
            "read": "jobs_read",
            "update": "jobs_update"
        },
        "agms": {
            "create": "agms_create"
        }
    }
 * @returns {JSX.Element}

 * @category Components - Admin Dashboard
 */
export const GroupPermissions = ({groupID, groupPermissions}) => {
    const [permissions, setPermissions] = useState();
    
    const { showLoading, hideLoading } = useLoading()
    const {showError} = useError()

    //set permissions when selected group (therefore groupPermissions) changes in parent component
    useEffect(() => {
        if(groupPermissions){
            const newPermissions = {...groupPermissions}
            setPermissions(newPermissions)
        }
    }, [groupPermissions])

    //update permissions state when toggle changed and saved in database
    const handleToggleChange = (resource, action, value, fail) => {
        if(!fail){    
            setPermissions((prevState) => {
                let newPermissions = { ...prevState };
        
                if (!newPermissions[resource]) {
                    newPermissions[resource] = {};
                }
        
                if (value) { 
                    newPermissions[resource][action] = `${resource}_${action}`;
                } else {
                    // Remove the key if value is false
                    delete newPermissions[resource][action];
        
                    // If the resource is empty after deleting the action, delete the resource key as well
                    if (Object.keys(newPermissions[resource]).length === 0) {
                        delete newPermissions[resource];
                    }
                }
        
                return { ...newPermissions };
            });
        }
    };

    //update permissions in database
    const updateGroupPermissions = async(permissionName, permissionResource, value) => {
        showLoading('Saving...')
        let reqBody = {
            permissionName,
            permissionResource
        }
        console.log(value)
        let response = await updateGroupPermissionsAPI(groupID, reqBody);
    
        if(!response.success){

            if(response){
                showError(response.message);
            } else {
                showError(response);
            }
            handleToggleChange(permissionResource, permissionName, value, true);
            
            hideLoading();

            return false

        } else {
            handleToggleChange(permissionResource, permissionName, value);
            
            hideLoading();

            return true
        }

    }

    //don't show component if we don't have groupId or permissions yet
    if(!groupID || !groupPermissions){
        return <div>Please select a group</div>
    }

    return(
        <>
            {/* make sure permissions are set in useEffect before showing table*/}
            {permissions 
            
                ? (
                <div className="my-10">
                    <Label>Group permissions</Label>

                    <div className='border rounded-sm w-fit'>
                        <table className='table-auto'>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th key={`create-head`} className='border text-center p-2'>Create</th>
                                    <th key={`read-head`} className='border text-center p-2'>Read</th>
                                    <th key={`update-head`} className='border text-center p-2'>Update</th>
                                    <th key={`delete-head`} className='border text-center p-2'>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {permissionResources.map((resourceName) => {
                                    
                                    return (
                                        <tr key={`${resourceName}-row`}>
                                            <td key={`${resourceName}-resource`} className='border text-center font-Poppins-Lig px-2'>{resourceName}</td>
                                            <td key={`${resourceName}-create-tog`} className='border text-center px-2'>
                                                <Toggle
                                                    checked={permissions[resourceName] && permissions[resourceName].create ? true : false}
                                                    id={`${resourceName}-create`}
                                                    labelText=''
                                                    locked={false}
                                                    onChange={(e) => updateGroupPermissions('create', resourceName, e)}
                                                />
                                            </td>
                                            <td key={`${resourceName}-read-tog`} className='border text-center px-2'>
                                                <Toggle
                                                    checked={permissions[resourceName] && permissions[resourceName].read ? true : false}
                                                    id={`${resourceName}-read`}
                                                    labelText=''
                                                    locked={false}
                                                    onChange={(e) => updateGroupPermissions('read', resourceName, e)}
                                                />
                                            </td>
                                            <td key={`${resourceName}-update-tog`} className='border text-center px-2'>
                                                <Toggle
                                                    checked={permissions[resourceName] && permissions[resourceName].update ? true : false}
                                                    id={`${resourceName}-update`}
                                                    labelText=''
                                                    locked={false}
                                                    onChange={(e) => updateGroupPermissions('update', resourceName, e)}
                                                />
                                            </td>
                                            <td key={`${resourceName}-delete-tog`} className='border text-center px-2'>
                                                <Toggle
                                                    checked={permissions[resourceName] && permissions[resourceName].delete ? true : false}
                                                    id={`${resourceName}-delete`}
                                                    labelText=''
                                                    locked={false}
                                                    onChange={(e) => updateGroupPermissions('delete', resourceName, e)}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            )
            : null
            }
        </>
    )
}